<template>
    <div class="md:pl-10 w-full md:w-3/4 md:pr-10">
        <template v-if="event.published">
            <h1 class="mb-6">Event Status</h1>

            <p class="mb-6">Your event has been published!</p>
            <p class="mb-6">
                Attendee count: {{ count }}
            </p>
            <p class="mb-6">
                <strong>Attendees</strong>
                <button @click.stop.prevent="exportEvent" class="button mb-12 ml-5">CSV Export</button>
            </p>
        </template>

        <template v-else>
            <template v-if="isReviewable">
                <h1 class="mb-6">Submit for Review</h1>

                <p class="mb-6">
                  When you have completed entering your event and ticketing information, please submit for review by the Reimagine team. Reimagine will review your event to ensure it's aligned with our mission and values prior to publishing. Reimagine reserves the right to not publish an event. Once the event is published and live on the Reimagine website, you will receive an email notification.                </p>
                <div class="mb-6">
                    <div class="my-3" ref="agree">
                        <p>By submitting the event and ticketing information, I acknowledge and agree: (A) the submitted information is governed by and is incorporated into and a part of the collaborator agreement; and (B) if I am submitting on behalf of an organization, I warrant that I am authorized by the organization to do so on its behalf</p>
                    </div>

                    <div class="mb-12">
                        <div class="select-box">
                            <label class="text-base font-normal">
                                <input type="checkbox"
                                    v-validate="'required'"
                                    v-model="agreeToTerms"
                                    name="agree">
                                <span class="check inline-block mr-2"></span> I agree to terms for event submission
                            </label>
                            <br><span v-show="errors.has('agree')" class="error text-error-red text-lg">{{ errors.first('agree') }}</span>
                        </div>
                    </div>
                    <button class="button mb-5" @click.stop.prevent="isSubmittable" :class="{ 'opacity-50 cursor-not-allowed': disableButton }" :disabled="disableButton">
                        <template v-if="saving">Processing...</template>
                        <template v-else>Submit for Review</template>
                    </button>
                    <p>PLEASE NOTE: You cannot submit for review until you have completed your Collaborator Agreement. If you receive an error message upon clicking the submit button above, you have not sufficiently provided some information. Please review your event and complete all required fields.</p>
                </div>
            </template>

            <template v-else>
                <h1 class="mb-6">Event Status</h1>

                <p class="mb-6">
                    Your event has been submitted for review! Please allow 1-2 business days for approval.
                </p>
            </template>
        </template>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import messaging from "../../../mixins/messaging";
    import validation from "../../../mixins/validation";
    import {analyticsDataLayer} from "../../../api/analyticsDataLayer";

    export default {
        name: "EventCreateSubmit",
        title: "Create Event Status",
        mixins: [messaging, validation],
        data: () => ({
            submitted: false,
            saving: false,
            agreeToTerms: false,
            validationPasses: false,
            eventErrors: [],
            attendees: {},
            count: 0
        }),
        computed: {
            ...mapGetters({
                event: "event",
                isLoading: "isLoading",
                user: "user"
            }),
            isReviewable() {
                if (this.event.published || this.submitted) {
                    return false;
                }

                if (this.event.status != "needs review") {
                    return true;
                } else {
                    return false;
                }
                return true;
            },
            disableButton() {
                if (this.isLoading || this.saving) {
                    return true;
                }

                return false;
            }
        },
        methods: {
            submitEvent() {
                let route = this.$laroute.route("api.events.update.submit", {
                    event: this.event.id
                });

                axios
                    .put(route)
                    .then(response => {
                        analyticsDataLayer.emit('event_submitted_for_review');
                        this.$toasted.show("Event has been submitted for review");
                        this.submitted = true;
                        this.saving = false;
                        this.$store.dispatch("setUnsavedData", false);
                    })
                    .catch(error => {
                        this.displayError(error);
                    });
            },

            exportEvent() {
                let route = this.$laroute.route("api.events.export", {
                    event: this.event.id
                });

                axios
                    .post(route)
                    .then(response => {
                        this.$toasted.show(
                            "Your request has been submitted and is processing. You should receive an email with an Attendee CSV shortly."
                        );
                    })
                    .catch(error => {
                        this.displayError(error);
                    });
            },

            isSubmittable() {
                this.saving = true;

                this.$validator.validateAll().then(result => {
                    if (!result) {
                        this.saving = false;
                        this.gotoFirstValidationError();
                        return;
                    }

                    let route = this.$laroute.route("api.events.submittable");

                    const form = this.event;
                    form.hasCreditAuthorization =
                        this.user.organization.creditAuthCompletedAt.length > 0
                            ? true
                            : false;

                    axios
                        .post(route, form)
                        .then(response => {
                            this.$toasted.show(
                                "Event being submitted for review..."
                            );
                            this.submitEvent();
                        })
                        .catch(errors => {
                            this.eventErrors = errors.response.data.errors;
                            this.saving = false;
                            this.$store.dispatch("setEventHasErrors", true);

                            let erros = _.flattenDeep(this.eventErrors.toString());
                            this.displayError(errors);
                        });
                });
            },
            attendeeCount() {
                const id = this.$route.params.id;
                let route = this.$laroute.route("api.events.attendees", {
                    event: id
                });

                axios
                    .get(route)
                    .then(response => {
                        this.attendees = response.data;
                        this.count = response.data.total;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },
        mounted() {
            const id = this.$route.params.id;
            this.$store.dispatch("getEvent", { id: id });
            document.getElementById("dropdown").checked = false;
            this.attendeeCount();
        }
    };
</script>
